import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import styles from "@/styles/article/return-policy.module.scss"
export default function TermsAndConditions() {

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-return-policy']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles['shop-info-box']}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <div className={styles['content-title']}>GENERAL CONDITIONS FOR USE OF THIS WEBSITE</div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              In the context of this website, &quot;we&quot;, &quot;our&quot; and &quot;us&quot; means CrazySales.com.au and may refer to either Ausway Pacific Pty Ltd or Huken Co (Business Registration No. 41035816-000-07-15-6) depending on the entity supplying the product (the website product listing states the seller and supplier of each product) and &quot;you&quot; and &quot;your&quot; means you, the user or customer of this website.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The use of the term &quot;product&quot; includes the plural &quot;products&quot;.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Except if otherwise required by law the following Terms and Conditions, the Contract of Sale and our Privacy Statement govern your use of this website. They describe the rights and responsibilities of both you and us. If you use this website you agree to be bound by the Terms and Conditions and if you shop at this website you agree to the terms of the Contract of Sale.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If you do not agree to the Terms and Conditions and the Contract of Sale and our Privacy Statement do not use this website.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We shall not be responsible for any detriment incurred by reliance you place on this website or its contents. Use of this website is on an &quot;as is&quot; basis and is entirely at your risk.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Which terms and conditions apply
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              These Terms and Conditions constitute a contract between the customer (You) and Ausway Pacific Pty Ltd ABN 66 166 623 169 (&quot;Trade as CrazySales&quot;)
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              1.CHANGES TO TERMS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Due to frequent changes in Internet technology and applicable laws, we reserve the right to make changes to these Terms and Conditions at any time technology and legal changes require. Please check these Terms and Conditions regularly for any such changes.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              2.CHANGES TO PRODUCTS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We and any persons involved with the management of this website may make changes to the products described and to other content of this website, at any time without notice.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We make every effort to ensure that product descriptions on our website are accurate. However some inaccuracies, typographical errors or misinterpretations may occur. We reserve the right to correct such inaccuracies or typographical errors as they are identified. We make no representations about the suitability of this information; it is provided &quot;as is&quot; without warranty of any kind.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              3.PRODUCT PRICES
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The price displayed for products on this website represents the full price, including GST, for the product itself but does not include postage/delivery charges which will depend on the destination.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We always seek to provide products at the most competitive prices, and because of the dynamic nature of this industry (e.g. vendor price changes and other variables beyond our control), prices, promotions, versions and availability advertised are subject to change without prior notice and we therefore reserve the right to change prices displayed for products on our website at any time.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Please be assured of our every effort to ensure the accuracy of our product pricing. However if an error is made and a product is listed at an incorrect price, we maintain the right to refuse to accept further orders and to cancel any orders already placed at the incorrect price. If an order has been confirmed and charged to your credit card we shall immediately contact you regarding your requirements for the reimbursement of money paid.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We sell and deliver products ONLY WITHIN Australia.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The information on this site is intended and applicable for Australian consumers only and is governed by Australian law.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              4.AGE RESTRICTIONS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              You must be at least eighteen (18) years of age to place an order with us. We do not knowingly accept orders from anyone under the age of 18.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              By placing an order with us through this website, you acknowledge that you are over eighteen (18) years of age.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Should we suffer any loss or damage as a result of a transaction entered into by a person under the age of 18, we reserve the right to seek compensation for such loss or damage from the parents or guardians of the person who placed the order(s) with us.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              5.INTERNET COMMUNICATIONS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              This website may:
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Store one or more cookies in your browser in order to improve service for you on your subsequent visits to this website; Request your browser to transmit this data back to the web server; or Request your browser to transmit a cookie that has been stored on your browser by another site within the same internet domain.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (<span style={{ fontWeight: '500' }}>Note</span>-Cookies are small pieces of data stored on the web browser on your computer. By using cookies, websites can track information about visitors&apos; use of the site and provide customised content. Most web browsers can be configured to notify the user when a cookie is received, allowing you to either accept or reject it. You may also inspect the cookies stored by your web browser and remove any that you do not want.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If you disable the use of cookies on your web browser or remove or reject specific cookies from this website or linked sites, then you may not be able to gain access to all the content and facilities of this website.)
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              6.INTELLECTUAL PROPERTY RIGHTS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Material contained on this website is protected by copyright. You may use this website only for your personal non-commercial purposes. Except to the extent permitted by relevant copyright legislation, you may not use, copy, modify, transmit, store, publish or distribute any material on this website or create any other material using material on this website, without obtaining our prior written consent.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Registered trade marks and logos must not be used or modified in any way without obtaining the prior written consent of the trade mark or logo owner.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The website, products, technology and processes contained in this website may be the subject of other intellectual property rights owned by third parties. No license is granted in respect of those intellectual property rights other than as set out in these Terms and Conditions. Your use of this website and material on it must not in any way infringe the intellectual property rights of any person.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              7.YOUR ACCOUNT
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              To purchase from us you must establish an account on this website.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We retain absolute discretion to refuse an account to be established, to terminate accounts, to remove or edit content where the account has not been kept in accordance with these terms and conditions.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              It is your responsibility to provide your exact email address, delivery address and billing address and telephone number and to keep these current. Any incorrect information provided may lead to a delay in delivery in or non-delivery of the product ordered.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              You are responsible for the confidentiality of your account password. Your password and account details are stored on a secure server for ease of use in processing future orders or for warranty claims. The information stored is only used to process your orders, for statistical purposes that may improve our website and its services, and to allow us to notify you of special offers or new products via our newsletters. Please refer to our Privacy Statement on this website. No credit card details are stored by us.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              8.SECURITY
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              When you register your personal details to establish an account or to place an order, a secure server is used. Secure Sockets Layer (SSL) encrypts the information you send through this website. We make no warranty in respect of the strength or effectiveness of that encryption and accept no responsibility for events arising from unauthorised access of the information you provide.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              9.CONTRACT OF SALE
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              These terms together with your order constitute the entire contract between you and us for the supply of products. No other terms will apply except where terms may be implied by law. The contract cannot be varied unless we agree to variations in writing or by email.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              10. LIMITATION OF LIABILITY
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              10.1 Limitation of Liability
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (a) Our liability to the Customer (and any party claiming through the Customer against us) for any claim for loss or damages (including legal expenses) made in connection with the Contract (including the supply of Goods described in the Contract) whether in contract, tort (including negligence), under statute, in equity or otherwise shall be strictly limited as follows (except to the extent that the law prohibits such a limitation):
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (i) for any liability arising from Goods not meeting the specification or which are said to be otherwise defective or deficient, our liability is limited to the cost of replacement of those Goods as soon as reasonably practicable, or the repair of those Goods or the repayment (or allowance) of the Purchase Price of those Goods (at the option of Our);
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (ii) for any liability arising from the services forming part of the Goods not meeting the scope
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              10.2 Consequential Loss
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (a) We may hold the Customer liable, to the maximum extent permitted by law, for any indirect, special or consequential loss or damage of any nature whatsoever resulting from or caused in any way by the Goods it supplies, where “indirect, special or consequential loss or damage” includes:
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (i) any loss of income, profit, production, contract, customers, business opportunity or business;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (ii) any loss of goodwill or reputation;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (iii) any loss or damage resulting from the loss or damage to goods other than the Goods.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              10.3 Defective Goods
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (a) Any claim by the Customer in respect of defective, non-conforming or damaged Goods must be made in writing within 14 days of the delivery of the Goods, unless a longer period is expressly agreed to by us in writing.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (b) Despite any other provision of the Contract, we are not liable, to the maximum extent permitted by law, for:
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (i) the cost of removal of Goods not meeting the specification or which are said to be otherwise defective or deficient, whether installed or otherwise;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (ii) the cost of installation of replacements for Goods not meeting the specification or which are said to be otherwise defective or deficient;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (iii) defects or deficiencies in Goods caused by improper installation or maintenance of Goods or related components or normal wear and tear and damage.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              11.PURCHASING PRODUCT(S)
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              You may place an order by clicking the &quot;Add to Cart&quot; button.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              When you place an order with us you have made an offer to purchase the product you have chosen and when we issue a tax invoice to you we have accepted your offer. Both offer and acceptance are based on these terms and conditions and are subject to any clause allowing for the cancellation of an order before property passes to you.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We will issue provide you with an Order Number by email after we have received your offer to purchase.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We will notify you when we process your order by sending you an Order Confirmation and tax invoice via email. To prevent credit card or payment fraud your offer can only be accepted by us after it has passed our validation procedures.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We retain discretion to cancel orders if our processes identify any attempt at fraud or for any other legitimate reason.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If for any reason we cannot process or accept your order after payment is received, we will contact you by email or telephone to determine your requirements for the reimbursement of money paid.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              12.PAYMENT
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We only accept payment through BPAY, PayPal and Credit cards (Visa and Master).
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Payment will not be processed until we have received all relevant information required for processing to be completed.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The processing of payment for Orders placed on a weekend or a Public holiday will not begin until the next working day.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Some payment options might be disabled for security purposes, if your preferred payment option is not available kindly select the next preferred option for payment.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              PayPal
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We process PayPal payments when you checkout from the product order screen.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              BPAY
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              When you pay by BPAY, you must pay the price payable as indicated on your Order Confirmation within 7 days from the date that you receive your Order Confirmation. Please note that BPAY payments take up to 2 working days to process.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We retain absolute discretion to cancel the transaction if a BPAY payment is not received within 7 days from the date that you receive your Order Confirmation.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              You must retain your tax invoice as proof of purchase.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Credit Cards
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We only accept Australian credit cards only. We do not accept international credit cards.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We process Credit cards payments when you checkout from the product order screen.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Whilst we employ the latest in Secure Sockets Layer (SSL) technology software for its transactions with our customers, we will not be responsible for any damages, consequential losses (whether direct or indirect) suffered by a customer whose credit card is fraudulently used or is used in an unauthorised manner.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If Your selected payment method triggers Our fraud prevention process, We may contact You to confirm additional details, or cancel the transaction. In this case, until Your Order has passed Our fraud prevention process, Your Order will not be fulfilled. If you fail to provide the requested information within 3 working days, Your Order will be cancelled and Your payment will be refunded back to the selected payment method. These information requests are sent to help protect credit card holders from online fraud.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              13.DELIVERY
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              You will be provided with an estimated delivery time when you checkout. The estimated delivery times are within working days Monday to Friday excluding public holidays. Normal delivery is within 3 to 14 working days from the date of payment.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We will make every effort to deliver your product within the estimated delivery time but the actual delivery times may change due to changes in supply or circumstances beyond our control.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We encourage you to visit the &quot;My Account&quot; section on our website to view the delivery status of your product. Please contact us if your item/s are not delivered within 45 days from the date of purchase, any claims of non-delivery outside this time frame will be considered delivered to you.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              <span style={{ fontWeight: '500' }}>Please note</span>: The investigation process can take upto 15 working days to resolve. Once our team receives any outcome from our 3rd party courier company we will contact you immediately to provide a resolution.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              PASSING OF PROPERTY
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Property in the product passes to you upon receipt of the product by you.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Please also note that deliveries with address on some farms, mine sites, islands, Aboriginal sacred sites and other regional or remote locations may not be accessible to our couriers and will not be able to deliver to your door steps. In such cases our courier will contact you for alternate delivery options.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              14.Warranty
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Statutory Conditions and Warranties
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              CrazySales provides a voluntary warranty and applies the Conditions and Warranties required by law.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Statutory Conditions and Warranties For all products sold by CrazySales provide conditions and warranties contained in the Commonwealth Competition and Consumer Act 2010.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Where the 30 Day Change-of-Mind Period has elapsed and the conditions provide that unless the product has defects which CrazySales specifically bring to your attention before the sale, the product is of merchantable quality-that is, the product is free from manufacturing defects and faults and reaches a basic level of quality given the price of the product and description that is provided with the product. The product is fit for the purpose or job for which it is normally supplied or to which CrazySales agreed before the sale. The product matches any description provided on our website or on labelling or packaging (See &quot;Changes to Product&quot;); and you receive clear title to the product
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The warranties provide that the product is clear of finance or encumbrances; and you will have free title to the product.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If the product does not fulfill any of these conditions or warranties then, provided the claim is made within a reasonable period after the sale, you may be entitled, at your discretion, to a refund, replacement of the product or to have it repaired. A reasonable period depends on the circumstances of each sale including but not limited to the nature, quality and price of the product.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Any refund agreed to may be less than the purchase price depending on any use or consumption of the product which has occurred or any contribution that use by you has made to the cause of the claim.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Customer Service will consider each claim on its merits on a case by case basis and, if required, will negotiate a solution that is acceptable to CrazySales and you including any costs involved.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              For more information about your rights as a consumer, see the ACCC website at www.accc.gov.au or download a free copy of the Warranties and Refunds Guide at http://www.accc.gov.au/accc-accc-wizard/mobile/1#acccWorkflowWizard1Path:1 .
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Exceptions
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We do not provide refunds, credit or exchange if you have:
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Damaged the product by using it in a way it was not meant to be used. You have had a defect drawn to your attention before you purchased the product, for example, when products are clearly labeled as seconds or faulty, The 30 Day Change-of-Mind period has elapsed and the product matches the description provided on our website and is free from manufacturing defects or faults.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Voluntary Warranty Policy
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              All products sold by CrazySales have a &quot;dead on arrival&quot; (DOA) warranty. This means that if the product is damaged during delivery and a claim is made within 14 days from the date of dispatch, CrazySales will replace or repair the product at our discretion and our cost. If CrazySales have no further stock of the item and it cannot be repaired CrazySales will replace it with a similar product or offer you a full refund.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If the damage is discovered outside the 14 day period contact Customer Service who will determine whether circumstances are such that you can still proceed with a claim. You can take advantage of this offer for up to twelve months after sale.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              This warranty does not apply to damage packaging only and does not detract from your statutory rights.
            </div>



            <div className={`${styles['ask-title']} padding-top-24`}>
              Manufacturers Voluntary Warranty
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Many of the products supplied by CrazySales are covered by a Manufacturers voluntary warranty. The terms and conditions of such warranties are beyond our control and it is your choice whether to use such warranties. Where possible the time of such warranty will be shown on our website. For some products it may be more efficient for you to contact the manufacturer rather than CrazySales. This is particularly so for electronic equipment. A manufacturers warranty does not detract from your statutory rights.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Making a Claim
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Provide us with a copy of your tax invoice or similar proof that the item was purchased from us. Describe accurately the problem you have encountered and provide evidence (erg a photograph) to support your claim State whether you are requesting a replacement, repair, refund or credit
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Return of Product for Warranty Claim
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              The CrazySales 30 Day Change-of-Mind Policy
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Online shopping sometimes means you don&apos;t get exactly what you had in mind. You are welcome to return the item as long as you meet the following terms and conditions as listed below:
            </div>

            <div className={`${styles['ask-title']} padding-top-24`}>
              Terms & Conditions
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • Notification is required within 30 days of purchase date.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • Item to be returned must be in their original re-saleable condition with all tags and packaging (ready to be put back on the shelf).
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • The item/s are NOT opened, used, worn or damaged.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • That you DO NOT stick or write anything on the item itself or its packaging. Please only write or place postage stickers on the outer postage packaging.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • Some items are not eligible for refund due to hygienic reasons.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • The refund amount will not include delivery costs. If the item was delivered for free, delivery cost will be deducted.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • Handling fees will apply at 20% of the purchase price.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • The return of the item is the responsibility of the buyer.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              • If the item has sustained damage in transit or does not return as noted above, a revised refund amount may be required.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If you would like to take this offer, please send us an email at info@crazysales.com.au and indicate the Order ID the item/s you wish to return and the reason for the return. Our Customer Service team will reply to your email and, if applicable, issue you a Return Authorization (RA) number. All other relevant information will be given to you at this time. Crazysales will not accept any return of any item/s without an RA from our Customer Service Representative.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Where the 30 Day Change-of-Mind period has elapsed and where Customer Service has determined that, on the facts you have provided, a claim may be granted. We will not accept the return of a product without approval from our Customer Service Team. The product must be returned to us within 30 calendar days from the approved date. Where possible, the product must be packed in the original, unmarked packaging including any accessories, manuals, documentation and registration that was delivered with the product.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We will provide our Reply Paid number which can be used to return products sent by Australia Post eParcel. In the case of products sent by our courier TOLL IPEC, we will send you contact details of our courier (TOLL IPEC) to organize pick up from your place.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We reserve the right to test any returned product, and to ask you to demonstrate that the problem with the product was not your fault. After the product has been returned a final decision on granting the claim will be made by Customer Services.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Where it is agreed that the claim is valid a replacement or repaired product will be returned to you at our expense.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Where upon receipt of the returned product we determine that the product did comply with the warranties and conditions and the condition of the product was misrepresented to us by you, the expense for the return of the product to us and the expense of returning the product to you will be deducted from your account as well as a $30.00 handling and administration fee.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              The CrazySales 30 Day PRE-ORDER price guarantee
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              30 days pre-order price guarantee applies to all pre-order items on sales in m.crazysales.com.au; www.crazysales.com.au
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              30 days refer to 30 calendar days after your order starts processing for delivery in our warehouse; 30 days period exclude following special promotion: Flash sales, End of financial year, Click Frenzy, Black Friday, Christmas promotion, Boxing day promotion.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Differences will be refund in form of Crazy Points, please contact our customer service with your order details and evident of lower price by e-mail to info@crazysales.com.au
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Refunds or credit
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Where a warranty claim is granted any refund will include all delivery and related costs for the product. Where a non warranty claim is granted any refund will be for the cost of the goods only and will exclude all related costs. No refund or replacement will be given until we have received the product from you. Refunds will be issued via payment method (EFT, PayPal, Polipay, AfterPay, etc) or a credit to your account.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Replacement
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Where a replacement is agreed to after a warranty claim is granted the replacement will be delivered to you at our expense after we have received your returned product. Where a non warranty claim is granted the replacement will be delivered to you at your expense.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Limitation of Liability
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (a) Our liability to the Customer (and any party claiming through the Customer against us) for any claim for loss or damages (including legal expenses) made in connection with the Contract (including the supply of Goods described in the Contract) whether in contract, tort (including negligence), under statute, in equity or otherwise shall be strictly limited as follows (except to the extent that the law prohibits such a limitation):
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (i) for any liability arising from Goods not meeting the specification or which are said to be otherwise defective or deficient, our liability is limited to the cost of replacement of those Goods as soon as reasonably practicable, or the repair of those Goods or the repayment (or allowance) of the Purchase Price of those Goods (at the option of Our);
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (ii) for any liability arising from the services forming part of the Goods not meeting the scope.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Consequential Loss
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (a) We may hold the Customer liable, to the maximum extent permitted by law, for any indirect, special or consequential loss or damage of any nature whatsoever resulting from or caused in any way by the Goods it supplies, where indirect, special or consequential loss or damage includes:
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (i) any loss of income, profit, production, contract, customers, business opportunity or business;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (ii) any loss of goodwill or reputation;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (iii) any loss or damage resulting from the loss or damage to goods other than the Goods.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Defective Goods
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (a) Any claim by the Customer in respect of defective, non-conforming or damaged Goods must be made in writing within 14 days of the delivery of the Goods, unless a longer period is expressly agreed to by us in writing.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (b) Despite any other provision of the Contract, we are not liable, to the maximum extent permitted by law, for:
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (i) the cost of removal of Goods not meeting the specification or which are said to be otherwise defective or deficient, whether installed or otherwise;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (ii) the cost of installation of replacements for Goods not meeting the specification or which are said to be otherwise defective or deficient;
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              (iii) defects or deficiencies in Goods caused by improper installation or maintenance of Goods or related components or normal wear and tear and damage.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              15.RESOLVING YOUR CONCERNS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If you have any concerns with, or do not understand, our Terms and Conditions we encourage you to contact us and we will make every endeavour to resolve your concerns.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Our contact details are below and we will respond to your query as soon as possible.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Email:info@crazysales.com.au Fax: (03) 9548 0779 Post: Customer Service Officer, PO BOX 1016, Springvale, VIC 3171.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              16.Returns
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If goods are faulty, not fit for purpose or do not match description, please contact our Customer Service team to resolve your issue.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Returns are accepted if sent back to us within 30 days of buyer receiving item.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The Package must be unopened.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              If you need to return an item, please Contact Us with your order number and details about the product you would like to return. We will respond with instructions for how to return items from your order. Terms and Conditions apply.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              Terms and conditions for GlobalOutlet Products
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              These Terms and Conditions constitute a contract between the customer (You) and Huken Co (Business Registration No. 41035816-000-07-15-6)   registered in Hong Kong (&quot;Trade as GlobalOutlet&quot;)
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              1.CHANGES TO TERMS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              Due to frequent changes in Internet technology and applicable laws we reserve the right to make changes to these Terms and Conditions at any time that technology and legal changes require. You should check these Terms and Conditions regularly for such changes.
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              2.CHANGES TO PRODUCTS
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We and any persons involved with the management of this website may make changes to the products described and to other content of this website, at any time without notice. We make every effort to ensure that product descriptions on our website are accurate. However some inaccuracies, typographical errors or misinterpretations may occur. We reserve the right to correct such inaccuracies or typographical errors as they are identified. We make no representations about the suitability of this information; it is provided &quot;as is&quot; without warranty of any kind
            </div>


            <div className={`${styles['ask-title']} padding-top-24`}>
              3.PRODUCT PRICES
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              The price displayed for products on this website represents the full price, for the product itself but does not include postage/delivery charges which will depend on the destination.
            </div>
            <div className={`${styles['answer-desc']} padding-top-10`}>
              We always seek to provide products at the most competitive prices, and because of the dynamic nature of this industry (e.g. vendor price changes and other variables beyond our control), prices, promotions, versions and availability advertised are subject to change without prior notice and we therefore reserve the right to change prices displayed for products on our website at any time. Please be assured of our every effort to ensure the accuracy of our product pricing. However if an error is made and a product is listed at an incorrect price, we maintain the right to refuse to accept further orders and to cancel any orders already placed at the incorrect price. If an order has been confirmed and charged to your credit card we shall immediately contact you to discuss options for resolving the discrepancy.
            </div>
            
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}